import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DxFunnelModule } from 'devextreme-angular/ui/funnel';
import { CardAnalyticsComponent } from '../card-analytics/card-analytics.component';

@Component({
  selector: 'dk-conversion-card',
  templateUrl: 'conversion-card.component.html',
  standalone: true,
  imports: [CommonModule, CardAnalyticsComponent, DxFunnelModule],
})
export class ConversionCardComponent {
  @Input() data: any;

  customizeOppText(arg: { valueText: string }) {
    return `$${arg.valueText}`;
  }
}
